/* eslint-disable no-undef */

const config = {
  aadb2cAuthorityDomain: process.env.REACT_APP_AADB2C_AUTHORITY_DOMAIN,
  aadb2cTenantName: process.env.REACT_APP_AADB2C_TENANT_NAME,
  aadb2cClientId: process.env.REACT_APP_AADB2C_CLIENT_ID,
  aadb2cUserFlow: process.env.REACT_APP_AADB2C_USER_FLOW_AGENT,
  aadb2cUserFlowAuthority: process.env.REACT_APP_AADB2C_USER_FLOW_AGENT_AUTHORITY,
  apiUrl: `${process.env.REACT_APP_API_BASE_URL}/api`,
  apiServiceUrl: `${process.env.REACT_APP_API_AGENTSPACE_SERVICE}/api`,
  artworkWorkspace: 'a08c07a1-f437-410c-ae08-dfc770a7bfa8',
  artworkViewPreferences: 'b79e564e-3cba-471b-8fc2-82f9ad36da36',
  forgotPasswordUrl: `https://${process.env.REACT_APP_AADB2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_AADB2C_TENANT_NAME}.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PASSWORDRESET&client_id=${process.env.REACT_APP_AADB2C_CLIENT_ID}&nonce=defaultNonce&redirect_uri=${window.location.origin}&scope=openid&response_type=id_token&prompt=login`,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  googleComponentRestrictions: { country: 'au' },
};

export default config;
